export const HEALTHNUMFLAG = "HEALTHNUMFLAG";
export const ADDHEALTHNUMBER = "ADDHEALTHNUMBER";
export const ADDHEALTHDETAILS = "ADDHEALTHDETAILS";
export const ALLHEALTHDETAILS = "ALLHEALTHDETAILS";
export const SUMINSURANCE_AMOUNT = "SUMINSURANCE_AMOUNT";
export const HEALTH_QUOTE = "HEALTH_QUOTE";
export const HEALTH_QQ_POST = "HEALTH_QQ_POST";
export const ERROR_QUOTES_HEALTH = "ERROR_QUOTES_HEALTH";
export const HEALTH_QQ_SINGLE = "HEALTH_QQ_SINGLE";
export const CUST_DETAIL_HEALTH = "CUST_DETAIL_HEALTH";
export const HEALTH_QUESTION = "HEALTH_QUESTION";
export const CREATE_PROPOSAL_HEALTH = "CREATE_PROPOSAL_HEALTH";
export const KYC_STATUS_HEALTH = "KYC_STATUS_HEALTH";
export const POLICY_PDF_Health = "POLICY_PDF_Health";
export const RESET_HEALTH = "RESET_HEALTH";
